<div [formGroup]="searchConditionForm">
  <mat-expansion-panel class="expansion-panel-card" [expanded]="true">
    <mat-expansion-panel-header class="mat-panel-header-text">
      <mat-panel-title>検索条件</mat-panel-title>
    </mat-expansion-panel-header>
    <div>
      <mat-form-field appearance="outline" class="input-form-date" floatLabel="always" style="width: 510px;">
        <mat-label>督促管理区分</mat-label>
        <input matInput style="display: none!important" formControlName="pressManagementdivisionCode">
        <mat-selection-list formControlName="pressManagementdivisionCode" class="tw-flex tw-flex-row tw-flex-wrap
          tw-box-border tw-justify-start tw-items-center tw-content-center
          tw-grow tw-shrink tw-basis-[510px]  tw-max-w-[510px] tw-min-w-[510px]" floatLabel="always"
          style="display:flex;">
          <mat-list-option *ngFor="let status of codeMap?.get('S300090')" [value]="status.userCode"
            (selectedChange)="getControl('pressManagementdivisionCode')?.markAsTouched()" class="mat-list-option"
            color="primary" checkboxPosition="before">
            {{status.hyojiCont}}
          </mat-list-option>
        </mat-selection-list>
      </mat-form-field>
    </div>
    <div class="tw-flex tw-flex-row tw-flex-wrap
      tw-box-border tw-justify-start tw-items-center tw-content-center" style="display:flex;">
      <mat-form-field appearance="outline" class="input-form-select">
        <mat-label>会社</mat-label>
        <mat-select formControlName="companycode" autocomplete="off" (valueChange)="onChangeCompany($event)">
          <mat-option [value]="null"></mat-option>
          <mat-option *ngFor="let company of companyList"
              [value]="company.value">{{company.viewValue}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-form-select">
        <mat-label>地区</mat-label>
        <mat-select formControlName="pressTantoAreacode" autocomplete="off">
          <mat-option [value]="null"></mat-option>
          <mat-option *ngFor="let chiku of chikuList" [value]="chiku.value">{{chiku.viewValue}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="tw-flex tw-flex-row tw-flex-wrap
      tw-box-border tw-justify-start tw-items-center tw-content-center" style="display:flex;">
      <mat-form-field appearance="outline" class="input-form-select">
        <mat-label>料金区分</mat-label>
        <mat-select formControlName="chargeDivcd" autocomplete="off">
          <mat-option [value]="null"></mat-option>
          <mat-option *ngFor="let type of codeMap?.get('S300620')"
            [value]="type.userCode">{{type.hyojiCont}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div>
      <mat-form-field appearance="outline" class="input-form-date" floatLabel="always" style="width: 510px;">
        <mat-label>サービサー委託ステータス</mat-label>
        <input matInput style="display: none!important" formControlName="servicerCommissionstatusCode">
        <mat-selection-list formControlName="servicerCommissionstatusCode" class="tw-flex tw-flex-row tw-flex-wrap
          tw-box-border tw-justify-start tw-items-center tw-content-center
          tw-grow tw-shrink tw-basis-[510px]  tw-max-w-[510px] tw-min-w-[510px]" floatLabel="always"
          style="display:flex;">
          <mat-list-option *ngFor="let status of statusList;" [value]="status.userCode"
            (selectedChange)="getControl('servicerCommissionstatusCode')?.markAsTouched()" class="mat-list-option"
            color="primary" checkboxPosition="before">
            {{status.hyojiCont}}
          </mat-list-option>
        </mat-selection-list>
      </mat-form-field>
    </div>
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-end tw-items-center tw-content-center"
      style="display:flex;">
      <mat-action-row class="btn_area_right expansion-panel-actions">
        <button type="submit" mat-raised-button color="primary" class="btn"
          [disabled]="searchConditionForm.invalid">検索</button>
      </mat-action-row>
      <mat-action-row class="btn_area_right expansion-panel-actions">
        <button type="button" mat-raised-button color="primary" class="btn" (click)="onClickClear()">クリア</button>
      </mat-action-row>
    </div>
  </mat-expansion-panel>
</div>